export default {
    status: '',
    token: '',
    userInfo: {},
    loading: false,
    emailForgot: '',
    permissionEdit: false
};
